module.exports = __webpack_public_path__ + "img/video_game2.01e7adaf.png";